import AvatarColorConstants from 'constants/AvatarColorConstants';
import { useCurrentUser } from 'hooks/users/queries';
import { ACTIVE_BUTTON_BLUE } from 'constants/ColorConstants';
import { BOT_USER_ID } from 'constants/UserConstants';

/**
 * Simple hash function to convert string to number
 * @param {string} str - String to hash
 * @returns {number} Hash value
 */
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

/**
 * Hook to get a consistent color for a user based on their ID
 * Uses a simple hash-based approach for consistency
 * @param {string|number} userId - The ID of the user
 * @returns {string} The color for the user
 */
export function useUserColor(userId) {
  const { data: currentUser } = useCurrentUser();
  
  if (!userId) {
    return AvatarColorConstants[0];
  }
  
  // Current user always gets blue
  if (currentUser && String(currentUser.id) === String(userId)) {
    return ACTIVE_BUTTON_BLUE;
  }
  
  // Special case: bot always gets second to last color
  if (userId === BOT_USER_ID) {
    return AvatarColorConstants[AvatarColorConstants.length - 2] || AvatarColorConstants[0];
  }
  
  // Hash the user ID and use modulo to pick a color
  const userIdString = String(userId);
  const hash = hashString(userIdString);
  const colorIndex = hash % AvatarColorConstants.length;
  
  return AvatarColorConstants[colorIndex];
}

export default useUserColor;